import { formatDate } from "../../../../_src_shared/utils/functions/formatDate";
import { formatPhone } from "../../../../_src_shared/utils/functions/formatPhone";
import { formatDollar } from "../../../../utils/numbers/formatDollar";
import PdfBuilderDataItemRow from "../../pdfBuilder/components/data/PdfBuilderDataItemRow";
import PdfSection from "../../pdfBuilder/components/layout/PdfSection";
import PdfSectionTitle from "../../pdfBuilder/components/typography/PdfSectionTitle";
import PdfPageBrandedSubmission from "../../pdfBuilder/pages/PdfPageBrandedSubmission";
import { addressLabel } from "../../../../_src_shared/utils/functions/addressLabel";

const PdfPageBorrowerInformation = ({ formData }) => {
  return (
    <PdfPageBrandedSubmission
      pageNumber={"1 of 6"}
      pageTitle={"Borrower Information"}
      submittedBy={`${formData?.firstName} ${formData?.lastName}`}
      submittedDate={formData?.submission_date}
    >
      <PdfSection>
        <PdfSectionTitle>Personal Details</PdfSectionTitle>

        <PdfBuilderDataItemRow
          label={"First Name:"}
          value={formData?.firstName}
        />

        <PdfBuilderDataItemRow
          label={"Last Name:"}
          value={formData?.lastName}
        />

        <PdfBuilderDataItemRow
          label={"Phone:"}
          value={formatPhone(formData?.phone)}
        />

        <PdfBuilderDataItemRow
          label={"Email:"}
          value={formData?.emailAddress}
        />

        <PdfBuilderDataItemRow
          label={"Date of Birth:"}
          value={formatDate(formData?.dateOfBirth)}
        />

        <PdfBuilderDataItemRow
          label={"Citizenship Status:"}
          value={formData?.citizenshipStatus}
        />

        <PdfBuilderDataItemRow
          label={"Primary Address:"}
          value={addressLabel(formData?.primaryAddress)}
        />

        <PdfBuilderDataItemRow
          label={"Marital Status:"}
          value={formData?.maritalStatus}
        />
        <PdfBuilderDataItemRow
          label={"SSN:"}
          type={"ssn"}
          value={formData?.borrowerSSN}
        />
      </PdfSection>

      <PdfSection>
        <PdfSectionTitle>Financial Information</PdfSectionTitle>

        <PdfBuilderDataItemRow
          label={"Cash Liquidity:"}
          value={formatDollar(formData?.cashLiquidity)}
        />

        <PdfBuilderDataItemRow
          label={"Other Liquidity:"}
          value={formatDollar(formData?.otherLiquidity)}
        />

        <PdfBuilderDataItemRow
          label={"Estimated FICO:"}
          value={formData?.estimatedFICO}
        />
      </PdfSection>
    </PdfPageBrandedSubmission>
  );
};

export default PdfPageBorrowerInformation;
